module.exports = "/_next/static/images/ShieldLogoWhite-cce72542c07d5702b8d6176c38c459ee.png";